import React, { useState, useEffect } from 'react';


function About() {
    const [animationActive, setAnimationActive] = useState(false);
  
    useEffect(() => {
      const handleScroll = () => {
        const aboutSection = document.getElementById('about');
        if (aboutSection) {
          const boundingRect = aboutSection.getBoundingClientRect();
          const windowHeight = window.innerHeight;
  
          if (boundingRect.top <= windowHeight / 2) {
            setAnimationActive(true);
          } else {
            setAnimationActive(false);
          }
        }
      };
  
      window.addEventListener('scroll', handleScroll);
  
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);
  
    return (
      <div className={`about-section ${animationActive ? 'animate' : ''}`} id="about">
        <div className="about-content">
          <div className="profile-image-frame">
            <img src="Velocity.png" alt="Adham Amer" className="profile-image" />
          </div>
          <div className="about-text-container">
            <h1 className="about-title">Unveiling the Developer Within</h1>
            <p className="about-introduction">
              Ahoy! I'm Adham Amer, the <span className="highlight">code artisan</span> who turns pixels into portals and imagination into interactivity.
            </p>
            <p className='text'>
            My journey in the world of software development began with a fascination for web technologies. I quickly immersed myself in the intricacies of HTML and CSS, perfecting the art of creating visually stunning and user-friendly websites. As my skills evolved, I delved into the realm of JavaScript, breathing life into static pages and making them interactive and dynamic.</p>
            <p className='text'>
            Driven by an insatiable curiosity, I ventured into the world of server-side scripting with PHP, efficiently managing data and enhancing the functionality of my projects. My love for elegant user interfaces led me to master React, enabling me to build cutting-edge web applications that prioritize both form and function.
            </p>
            <p className='text'>
            But my quest for knowledge didn't stop there. Recognizing the immense potential of mobile app development, I dived into Java, harnessing its power to create Android applications that seamlessly blend innovation with usability. This journey has been one of continuous growth, and I'm always excited to embrace new challenges and technologies that keep pushing the boundaries of what I can achieve.            </p>
            <p className="about-call-to-action">
              So, whether you're looking to create a digital masterpiece or brainstorm a concept, let's embark on a <span className="highlight">collaborative voyage</span> that transcends boundaries.
            </p>
          </div>
        </div>
      </div>
    );
  }

export default About;
